import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Collapse, Row, Tabs } from 'antd';

import * as actions from '../../actions';
import { formatProgress } from '../../util/formatProgress';
import { cleanString, createMarkup } from '../../util/renderHelper';
import { ReactComponent as IconChevronRight } from '../Sprites/icon-chevron-right.svg';
import NewsList from './NewsList';
import ResourceList from './ResourceList';

const { Panel } = Collapse;
const { TabPane } = Tabs;

const DesktopTabs = ({ tabs, defaultKey }) => {
  const displayTabs = tabs.map((tabPane, key) => {
    return (
      <TabPane key={key} tab={cleanString(tabPane.name)}>
        <div
          dangerouslySetInnerHTML={createMarkup(cleanString(tabPane.contents))}
        />
        <NewsList tabName={cleanString(tabPane.name)} />
        <FileList hasFiles={tabPane.hasFiles} id={tabPane.id} />
      </TabPane>
    );
  });
  return (
    <Tabs
      type="card"
      defaultActiveKey={defaultKey.toString()}
      className="tabs"
      aria-keyshortcuts="ArrowLeft ArrowRight"
    >
      {displayTabs}
    </Tabs>
  );
};

const FileList = ({ hasFiles, id }) =>
  hasFiles ? <ResourceList tabPaneID={id} /> : null;

const MobileCollapse = ({ panels }) =>
  panels.map((panel, key) => (
    <Collapse
      key={`provider-collapse-${key}`}
      className="collapse"
      expandIconPosition="right"
      expandIcon={({ isActive }) => (
        <span>
          <IconChevronRight />
        </span>
      )}
    >
      <Panel header={cleanString(panel.name)} key="1">
        <div
          dangerouslySetInnerHTML={createMarkup(cleanString(panel.contents))}
        />
        <NewsList tabName={cleanString(panel.name)} />
        <FileList hasFiles={panel.hasFiles} id={panel.id} />
      </Panel>
    </Collapse>
  ));

class ProviderTabs extends Component {
  static displayName = 'ProviderTabs';

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { updateProgress } = this.props;
    const componentProgress = formatProgress(this.constructor.displayName, true);
    updateProgress(componentProgress);
  }

  render() {
    const { isMobile, tabs, defaultKey } = this.props;

    return !!tabs.length ? (
      <section id="provider-tabs" className="provider-tabs">
        <Row className="fixed">
          <Col xs={{ span: 22, offset: 1 }} lg={{ span: 24, offset: 0 }}>
            <div className="main">
              <div id="provider-tabs">
                {isMobile ? (
                  <MobileCollapse panels={tabs} />
                ) : (
                  <DesktopTabs tabs={tabs} defaultKey={defaultKey} />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </section>
    ) : null;
  }
}

const mapStateToProps = state => ({
  isMobile: state.app.isMobile,
  progress: state.app.progress,
  tabs: state.providerDetails.data.tabs,
  defaultKey : state.currentProviderContent.providerTab,
});

const mapDispatchToProps = dispatch => ({
  updateProgress: progress =>
    dispatch(actions.appActions.updateProgress(progress)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProviderTabs);
